import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IUserFilterStrings extends LocalizedStringsMethods {
    lsUsrName: string;
    lsFName: string;
    lsLName: string;
    lsEmail: string;
    lsRoles: string;
    lsOrgTxt: string;
}

let strings: IUserFilterStrings;
export default strings = new LocalizedStrings({
    en: {     
        lsUsrName: 'Username',
        lsFName: 'First Name',
        lsLName: 'Last Name',
        lsEmail: 'Email',
        lsRoles: 'Roles',
        lsOrgTxt: 'Organization'  
    },
    es: {
        lsUsrName: 'Nombre de usuario',
        lsFName: 'Nombre de pila',
        lsLName: 'Apellido',
        lsEmail: 'Email',
        lsRoles: 'Roles',
        lsOrgTxt: 'Organización'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/user/string.user.filter.tsx